import * as graphql from '@treams/treams-network';

export default function trim(
	groups: graphql.Group[],
	canSelect: (group: graphql.Group) => boolean,
): graphql.Group[] {
	const map = new Map<string, graphql.Group>(groups.map((group) => [group.id, group]));
	const results: graphql.Group[] = [];

	const preserve = new Set();

	for (const candidate of groups) {
		let id: string | undefined = candidate.id;

		if (!canSelect(candidate)) {
			continue;
		}

		while (id !== undefined) {
			const group = map.get(id);

			if (group) {
				preserve.add(group.id);
			}

			id = group?.parent?.id;
		}
	}

	for (const candidate of groups) {
		let id: string | undefined = candidate.id;
		let isArchived = false;

		const visited = new Set();

		while (id !== undefined) {
			if (visited.has(id)) {
				break;
			}

			visited.add(id);

			const group = map.get(id);

			isArchived = isArchived || !!group?.isArchived;
			id = group?.parent?.id;
		}

		if (
			(!candidate.parent && candidate.type === graphql.GroupType.Department) ||
			(!isArchived && preserve.has(candidate.id))
		) {
			results.push(candidate);
		}
	}

	return results;
}
